import { AlertColor } from '@mui/material'
import { atom } from 'recoil'

export type Toast = {
  title: string
  severity: AlertColor
}

const toastAtom = atom<Toast | null>({
  key: 'toast',
  default: null,
})

export { toastAtom }
